const isDateValid = (d: Date | any): boolean => {
  // @ts-ignore
  return d instanceof Date && !isNaN(d);
};

export default isDateValid;
